<script setup lang="ts">
import type { LayoutConfigGridBreakpointInterface, LayoutConfigGridConfigInterface } from '@voix/types'
import type { ComputedRef } from 'vue'
import { useNuxtApp } from '#imports'

import { useLayoutStore } from '@voix/store/layoutStore'

import { computed, ref } from 'vue'

const props = defineProps({
  layout: String,
})

const { $voix } = useNuxtApp()
const layoutStore = useLayoutStore()
const layouts = computed(() => layoutStore.layouts)

const currentLayoutConfig = computed(() => {
  if (!props.layout || !layouts.value[props.layout])
    return null

  return layouts.value[props.layout]
})

const currentGridConfig: ComputedRef<null | LayoutConfigGridConfigInterface> = computed(() => {
  if (!currentLayoutConfig.value || !currentLayoutConfig.value.grid)
    return null

  return currentLayoutConfig.value.grid
})

const currentGridBreakpointConfig: ComputedRef<null | LayoutConfigGridBreakpointInterface> = computed(() => {
  // If there is no config or no breakpoints, return null
  if (!currentGridConfig.value || Object.keys(currentGridConfig.value).length < 1)
    return null

  // Loop through the breakpoints and return the first one that is less than the viewerWidth
  let theLastBreakpoint: string | null = null
  for (const [breakpointKey] of Object.entries(currentGridConfig.value)) {
    if (theLastBreakpoint && $voix.breakpoint.isLessThan(breakpointKey))
      return currentGridConfig.value[theLastBreakpoint]

    theLastBreakpoint = breakpointKey
  }

  if (theLastBreakpoint)
    return currentGridConfig.value[theLastBreakpoint]

  return currentGridConfig.value.default
})

const currentGridBreakpointContainer = computed(() => {
  return currentGridBreakpointConfig?.value?.container === true
})

const currentGridBreakpointGutter = computed(() => {
  return currentGridBreakpointConfig?.value?.gutter || 0
})
const currentGridBreakpointColumns = computed(() => {
  return currentGridBreakpointConfig?.value?.columns || 12
})

const currentGridBreakpointGap = computed(() => {
  if (typeof currentGridBreakpointConfig.value?.gap === 'number')
    return `${currentGridBreakpointConfig.value?.gap}px`

  return currentGridBreakpointConfig.value?.gap || '1rem'
})
</script>

<template>
  <div
    v-if="currentGridBreakpointColumns" class="fixed z-50 inset-0 pointer-events-none" :style="{
      padding: `0 ${currentGridBreakpointGutter}`,
    }"
  >
    <div
      class="grid h-screen"
      :class="{ container: currentGridBreakpointContainer }"
      :style="[
        `column-gap: ${currentGridBreakpointGap}`,
        `grid-template-columns: repeat(${currentGridBreakpointColumns}, minmax(0, 1fr))`,
      ]"
    >
      <div v-for="n in currentGridBreakpointColumns" :key="n" class="bg-red-500/50" />
    </div>
  </div>
</template>
